import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {tokenInterceptor} from './token-interceptor';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ErrorPageComponent } from './error-page/error-page.component';
import { DsiOverviewComponent } from './dsi-overview/dsi-overview.component';
import {DsiFooterComponent} from './dsi-overview/dsi-footer/dsi-footer.component';

registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    DsiOverviewComponent
  ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule.forRoot(),
        FontAwesomeModule,
        DsiFooterComponent,
    ],
  providers: [
    provideHttpClient(
      withInterceptors([tokenInterceptor])
    ),
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
